import Rails from "@rails/ujs";
import "bootstrap";
import { noNullQuerySelector } from "../src/utils/dom";
import "../src/utils/partytown";

document.addEventListener("DOMContentLoaded", () => {
  try {
    Rails.start();

    const hamburgerOffcanvasCloseButton = noNullQuerySelector(
      "#close-hamburger-offcanvas",
    );
    document
      .querySelector("#how-it-works-link")
      ?.addEventListener("click", (e) => {
        e.preventDefault();
        const howItWorksSection = document.querySelector(
          "#simple-process-section",
        );
        if (howItWorksSection) {
          howItWorksSection.scrollIntoView({ behavior: "smooth" });
        }
        hamburgerOffcanvasCloseButton.click();
      });
  } catch (e) {}
});
